import React from "react";
import PropTypes from "prop-types";

import { useSelector, useDispatch } from "react-redux";

import { setRangeSelectParams } from "@/src/store/filter";

import { numberFormatter } from "@/src/helpers/number-formatter";
import { onlyNumber } from "helpers/only-number";

import Input from "@/src/components/common/input";

import styles from "@/src/components/listing-search/filter-items/styles.module.css";

const MinInput = ({ filter, filterKey }) => {
  const reduxRangeItems = useSelector((state) => state.filter.rangeselectitems);

  const dispatch = useDispatch();

  const handleChangeRangeInput = (filterKey, event) => {
    const newValue = event.target.value?.replaceAll(".", "");
    if (!onlyNumber(newValue) && newValue !== "") return;
    const findParams = reduxRangeItems?.find((item) => item.key === filterKey) || {};

    const filterObject = {
      key: filterKey,
      value: {
        min: newValue || findParams?.value?.min,
      },
    };

    const newCriteriaParams = reduxRangeItems?.filter((item) => item.key !== filterKey);
    newCriteriaParams.push(filterObject);
    dispatch(setRangeSelectParams(newCriteriaParams));
  };

  const minValue = numberFormatter(reduxRangeItems.find((item) => item.key === filterKey)?.value?.min) || "";

  return (
    <div className={styles.searchInput}>
      <Input
        placeholder={filter.name}
        value={minValue}
        onChange={(event) => handleChangeRangeInput(filterKey, event)}
        inputClass={styles.minMaxInput}
      />
    </div>
  );
};

MinInput.propTypes = {
  filter: PropTypes.object,
  filterKey: PropTypes.string,
};

export default MinInput;
